// utils/formatNice.ts
export function formatNice(str) {
  return str
    .toString()
    .trim()
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function resolved(val, custom) {
  // prefer custom only when the stored value is literally "Other"
  return val === "Other" ? (custom || "N/A") : (val || "N/A");
}

/** pick the final label from a (value,custom) pair, then prettify */
export function pretty(val, custom) {
  return formatNice(resolved(val, custom));
}
